/**
 * Publishes the disabled-feature configuration for every Impact0mics module.
 *
 * This app is the only one that defines VITE_DISABLED_CTA_TENANT_ID and
 * VITE_DISABLED_CTA_ROLES. It writes them to localStorage under the key owned by
 * @clairlabs-ai/impactomics-common-layout, and the sample, patient and layout
 * packages read that entry instead of carrying their own copies of the env vars.
 *
 * Call this on app load and again after the login screen clears storage.
 */

import { publishFeatureRestrictionsFromEnv } from "@clairlabs-ai/impactomics-common-layout";

export function publishFeatureRestrictions(): void {
  publishFeatureRestrictionsFromEnv({
    tenantId: import.meta.env.VITE_DISABLED_CTA_TENANT_ID,
    roles: import.meta.env.VITE_DISABLED_CTA_ROLES,
  });
}
